import { gql } from 'apollo-angular';

export const modulePageTasks = gql`
	fragment ModulePageTasks on ModuleTaskOutput {
		id
		type
		position
		updateTimestamp
		localizations {
			title
			locale
			category
			description
		}
	}
`;
